import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field } from 'redux-form'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { getBusinessPartners } from 'ducks/options'
import { getVendorDetail } from 'ducks/shortList'
import { VendorInfoFormContainer } from './styled'
import { validations, validateCase as vCase } from 'core/validate'

// import r from 'reactotron-react-js'

const VendorSelectModal = (props) => {
  const { valueForm, businessPartners, onClose, onSelect, selectedVendor = [] } = props

  useEffect(() => {
    if (!businessPartners.data.length && !businessPartners.loading) {
      props.getBusinessPartners()
    }
  }, [])

  return (
    <Dialog className='dialog-full-height' open={true} maxWidth='sm' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Vendor</DialogTitle>
      <DialogContent>
        <VendorInfoFormContainer>
          <form>
            <div className='rowFields'>
              <Field 
                name='vendorCode' 
                label='Vendor' 
                require
                options={businessPartners.data.filter(v => !selectedVendor.includes(v.value))}
                loading={businessPartners.loading}
                type={type.select} 
                component={FieldInput} 
              />
            </div>
          </form>
        </VendorInfoFormContainer>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={() => onSelect(valueForm.vendorCode)} >Select</Button>
        <Button color='secondary' onClick={() => onClose()} >Cancel</Button>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const vendorData = props.vendorData || {}

  return ({
    businessPartners: state.options.businessPartners,
    valueForm: getFormValues('formShortListVendorSelect')(state) || {},
    initialValues: {
      id: vendorData.id || null,
      vendorCode: vendorData.vendorCode || ''
    }
  })
}
  

const mapDispatchToProps = {
  getBusinessPartners,
  getVendorDetail
}

const validate = (values) => {
  let errors = {}
  validations(values, 'vendorCode', [vCase.require], errors)

  return errors
}

const VendorSelectModalForm = reduxForm({
  form: 'formShortListVendorSelect',
  enableReinitialize: true,
  validate
})(VendorSelectModal)

export default connect(mapStateToProps, mapDispatchToProps)(VendorSelectModalForm)